import { filterPermittedActionsWithDividers } from '../../../../utils/massActions'
import {
  EMAIL_ACTION_ATTACH_REQUEST,
  EMAIL_ACTION_CREATE_SERVICE_REQUEST,
} from '../../Email.constants'

export function getActions({ permissions, t }) {
  return filterPermittedActionsWithDividers([
    {
      label: t('Emails.CreateServiceRequestActionOptionKey'),
      permission: permissions.can_create_request,
      value: EMAIL_ACTION_CREATE_SERVICE_REQUEST,
    },
    {
      label: t('Emails.AttachRequestActionOptionKey'),
      permission: permissions.can_attach_to_request,
      value: EMAIL_ACTION_ATTACH_REQUEST,
    },
  ])
}
